/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignUsageRequestMorePathParams,
	CampaignUsageRequestMoreRequest,
	CampaignUsageRequestMoreResponse,
} from '../types/CampaignUsageRequestMore'

/**
 * POST /:organisation/campaign-usage/request-more
 * @see backend/nexus/modules/Billing/Http/Controllers/CampaignUsageController.php CampaignUsageController::requestMore
 */
export async function campaignUsageRequestMore(
	organisation: CampaignUsageRequestMorePathParams['organisation'],
	data: CampaignUsageRequestMoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignUsageRequestMoreResponse>> {
	return axiosInstance.post(`/${organisation}/campaign-usage/request-more`, data, config)
}
